'use client'

/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable multiline-ternary */

import { useState } from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import ButtonLoader from '@components/Home/PrimaryButton/loader'
import { getVideoAssetStreamData, getVideoAssetThumbnails } from '@readers/videoReader'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import styles from './Video.module.scss'

const VideoJsPlayer = dynamic(
  () => import('@components/VideoTmp/videoPlayer'),
  { ssr: false }
)

const VideoPlayer = ({ isMobile, videoContentFull }) => {
  const [showVideo, setShowVideo] = useState(false)
  const [playerReady, setPlayerReady] = useState(false)

  const { videoThumbnailWeb, videoThumbnailMobile } = getVideoAssetThumbnails(videoContentFull?.video_asset)
  const { videoData, platform } = getVideoAssetStreamData(videoContentFull?.video_asset)

  const handleThumbnailClick = () => {
    setShowVideo(true)
  }

  return (
    <div className={styles.videoDiv}>
      {!playerReady && (
        <div id="thumbnailContainer" className={styles.thumbnailContainer} onClick={handleThumbnailClick}>
          {!showVideo
            ? <Image
              src="https://acko-seo-prod-assets.ackoassets.com/_next_static/images/videoPlay.svg"
              width={72}
              height={72}
              alt="Video play icon"
              loading="lazy"
              decoding="async"
              className={styles.playIcon}
            /> : <div className={styles.playIcon}><ButtonLoader /></div>
          }
          <Image
            src={
              !isMobile
                ? videoThumbnailWeb
                : videoThumbnailMobile
            }
            fill
            alt="Video Thumbnail"
            loading="lazy"
            decoding="async"
            className={styles.thumbnail}
          />
        </div>
      )}
      <PropertyControlledComponent fallback={null} controllerProperty={showVideo && videoData}>
        <div className={`${styles.videoVimeo} ${playerReady ? styles.showVideo : styles.hideVideo}`}>
          <VideoJsPlayer data={videoData} platform={platform} autoplay setPlayerReady={setPlayerReady}/>
        </div>
      </PropertyControlledComponent>
    </div>
  )
}

export default VideoPlayer
